export const QUEST_STYLES = {
  1: {
    cardBg: "bg-grey-shadow",
    cardBorder: "border-neutral-gray",

    iconBg: "/assets/quests/quest-bg-1.jpg",
  },
  2: {
    cardBg: "bg-dark-blue",
    cardBorder: "border-medium-blue",

    iconBg: "/assets/quests/quest-bg-2.jpg",
  },
  3: {
    cardBg: "bg-dark-purple",
    cardBorder: "border-light-purple",
    iconBg: "/assets/quests/quest-bg-3.jpg",
  },
  4: {
    cardBg: "bg-dark-orange",
    cardBorder: "border-bright-orange",
    iconBg: "/assets/quests/quest-bg-4.jpg",
  },
  5: {
    cardBg: "",
    cardBgImage: "/assets/quests/quest-bg-5.gif",
    cardBorder: "border-silver-gray",
    iconBg: "/assets/quests/quest-bg-5.jpg",
  },
} as const;

export const QUEST_RARITY_POPUP_LABELS: Record<string, string> = {
  "1": "New quest",
  "2": "New rare quest",
  "3": "New epic quest",
  "4": "New legendary quest",
  "5": "New vorpal quest",
};

export const DEFAULT_QUEST_STYLE = {
  cardBg: "bg-grey-shadow",
  cardBorder: "border-dark-grey",
  iconBg: "/assets/quests/quest-bg-4.jpg",
} as const;

export const BONUS_CONFIG: Record<string, Record<string, number>> = {
  "2": {
    "3": 1, // After 3 claimed sessions → 3x reward bonus
  },
  "3": {
    "7": 2, // After 7 claimed sessions → 5x reward bonus
  },
  "4": {
    "7": 2, // After 7 claimed sessions → 5x reward bonus
    "14": 3, // After 14 claimed sessions → 5x reward bonus
  },
  "5": {
    "7": 2,
    "14": 3,
    "21": 3,
    "28": 3,
    "30": 5,
  },
};
